import { TYPES } from 'action-types/mdm';
import {
    IMdmModel,
} from 'reducers/mdm/models';

export interface ImdmAction {
    readonly type: string;
    readonly errors?: string | string[];
    readonly mdm: IMdmModel[];
    readonly printers: any[];
    readonly outputs: any[];
    readonly reasonCodes: any[];
    readonly category: any;
}

export interface IMdmState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly pendingError: string | null;

    readonly isPrinterDataLoading: boolean;
    readonly isPrinterDataError: boolean;
    readonly printerError: string | null;

    readonly isOutputsDataLoading: boolean;
    readonly isOutputsDataError: boolean;
    readonly outputsError: string | null;

    readonly isReasonCodesLoading: boolean;
    readonly isReasonCodesDataError: boolean;
    readonly reasonCodesError: string | null;

    readonly mdm: IMdmModel[];
    readonly printers: any[];
    readonly outputs: any[];
    readonly reasonCodes: any[];
    readonly reasonCodesWithCategory: any;
}

export const defaultState: IMdmState = {
    isFetchDataError:false,
    pendingError: null,
    isFetchDataLoading: false,
    isPrinterDataLoading: false,
    isPrinterDataError: false,
    printerError: null,
    isOutputsDataLoading: false,
    isOutputsDataError: false,
    outputsError: null,
    isReasonCodesLoading: false,
    isReasonCodesDataError: false,
    reasonCodesError: null,
    mdm: [],
    printers: [],
    outputs: [],
    reasonCodes:[],
    reasonCodesWithCategory: {}
};

export const reducer = (state: IMdmState = defaultState, action: ImdmAction): IMdmState => {
    switch (action.type) {
        case TYPES.FETCH_PRINTER.PENDING:
            return {
                ...state,
                isPrinterDataLoading: true,
                isPrinterDataError: false,
                printerError: null
            };
        case TYPES.FETCH_PRINTER.FULFILLED:
            return {
                ...state,
                printers: action.printers,
                isPrinterDataLoading: false,
                isPrinterDataError: false,
                printerError: null
            };
        case TYPES.FETCH_PRINTER.REJECTED:
            return {
                ...state,
                isPrinterDataLoading: false,
                isPrinterDataError: true,
                printerError: action.errors?action.errors.toString():''
            };
        case TYPES.FETCH_OUTPUT.PENDING:
            return {
                ...state,
                isOutputsDataLoading: true,
                isOutputsDataError: false,
                outputsError: null
            };
        case TYPES.FETCH_OUTPUT.FULFILLED:
            return {
                ...state,
                outputs: action.outputs,
                isOutputsDataLoading: false,
                isOutputsDataError: false,
                outputsError: null
            };
        case TYPES.FETCH_OUTPUT.REJECTED:
            return {
                ...state,
                isOutputsDataLoading: false,
                isOutputsDataError: true,
                outputsError: action.errors?action.errors.toString():''
            };
        case TYPES.FETCH_MDM_CODE.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: null
            };
        case TYPES.FETCH_MDM_CODE.FULFILLED:
            return {
                ...state,
                mdm: action.mdm,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: null
            };
        case TYPES.FETCH_MDM_CODE.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.type? action.type.replace(/_/g, ' '): action.errors?action.errors.toString():''
            };
        case TYPES.FETCH_REASON_CODES_OUTPUT.PENDING:
            return {
                ...state,
                isReasonCodesLoading: true,
                isReasonCodesDataError: false,
                reasonCodesError: null
            };
        case TYPES.FETCH_REASON_CODES_OUTPUT.FULFILLED:
            return {
                ...state,
                reasonCodes: action.reasonCodes,
                reasonCodesWithCategory: {
                    [action.category] : action.reasonCodes
                },
                isReasonCodesLoading: false,
                isReasonCodesDataError: false,
                reasonCodesError: null
            };
        case TYPES.FETCH_REASON_CODES_OUTPUT.REJECTED:
            return {
                ...state,
                isReasonCodesLoading: false,
                isReasonCodesDataError: true,
                reasonCodesError: action.errors?action.errors.toString():''
            };
        default:
            return state;
    }
};
